import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { GearFieldWrapper } from '../GearFieldWrapper';
import { Input } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { searchIcon } from '@progress/kendo-svg-icons';

interface FormSearchableInputProps extends FieldRenderProps {
  min?: number;
  max?: number;
  isLoading?: boolean;
  onSearch?: (value: string) => void;
}

export const FormSearchableInput: React.FC<FormSearchableInputProps> = fieldRenderProps => {
  const { min, max, isLoading, onSearch, disabled, ...restProps } = fieldRenderProps;

  const handleChange = (event: any) => {
    restProps.onChange?.(event);
  };

  const handleSearchClick = () => {
    if (onSearch && restProps.value) {
      onSearch(restProps.value);
    }
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter' && onSearch && restProps.value) {
      onSearch(restProps.value);
    }
  };

  return (
    <GearFieldWrapper {...restProps}>
      <div className="gearSearchableInputWrapper">
        <Input
          name={restProps.name}
          valid={restProps.valid}
          value={restProps.value || ''}
          defaultValue={restProps.defaultValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          validationMessage={restProps.validationMessage || undefined}
          placeholder="Enter value and click search..."
          disabled={disabled || isLoading}
          minLength={min}
          maxLength={max}
        />
        <Button
          type="button"
          svgIcon={searchIcon}
          fillMode="flat"
          onClick={handleSearchClick}
          disabled={disabled || isLoading || !restProps.value}
          className="gearSearchButtonInside"
          title="Search"
        />
      </div>
    </GearFieldWrapper>
  );
};
